import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_DIAGNOSES_REQUEST, fetchDiagnosesSuccess, fetchDiagnosesFailure,
  CREATE_DIAGNOSIS_REQUEST, createDiagnosisSuccess, createDiagnosisFailure,
  UPDATE_DIAGNOSIS_REQUEST, updateDiagnosisSuccess, updateDiagnosisFailure,
  DELETE_DIAGNOSIS_REQUEST, deleteDiagnosisSuccess, deleteDiagnosisFailure
} from '../actions/diagnosisActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');

const createConfig = () => ({
  headers: { 'Authorization': `Bearer ${authToken}` }
});

function* fetchDiagnoses(action) {
  try {
    const token = getAuthToken();
    const { projectId, page = 1, limit = 2, search = '', group = '' } = action.payload || {};

    console.log("Fetching diagnoses data with payload: ", { projectId, page, limit, search, group });

    const baseUrl = getBaseUrl();

    const response = yield call(
      axios.get,
      `${baseUrl}/${projectId}/diagnosis`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );

    // Assuming response structure includes `data` and `meta`
    yield put(fetchDiagnosesSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "An unknown error occurred";
    console.error("Error fetching daignoses data: ", errorMessage);
    yield put(fetchDiagnosesFailure(errorMessage));
  }
}

function* createDiagnosis(action) {
  try {
    const response = yield call(axios.post, `${API_BASE_URL}/${action.payload.projectId}/diagnosis`, action.payload.data, createConfig());
    yield put(createDiagnosisSuccess(response.data));
  } catch (error) {
    yield put(createDiagnosisFailure(error.message));
  }
}

function* updateDiagnosis(action) {
  try {
    const { id, data,projectId } = action.payload;
    const response = yield call(axios.put, `${API_BASE_URL}/${projectId}/diagnosis/${id}`, data, createConfig());
    yield put(updateDiagnosisSuccess(response.data));
  } catch (error) {
    yield put(updateDiagnosisFailure(error.message));
  }
}

function* deleteDiagnosis(action) {
  try {
    const { id ,projectId} = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/${projectId}/diagnosis/${id}`, createConfig());
    yield put(deleteDiagnosisSuccess(id));
  } catch (error) {
    yield put(deleteDiagnosisFailure(error.message));
  }
}

export default function* diagnosisSaga() {
  yield takeLatest(FETCH_DIAGNOSES_REQUEST, fetchDiagnoses);
  yield takeLatest(CREATE_DIAGNOSIS_REQUEST, createDiagnosis);
  yield takeLatest(UPDATE_DIAGNOSIS_REQUEST, updateDiagnosis);
  yield takeLatest(DELETE_DIAGNOSIS_REQUEST, deleteDiagnosis);
}
